import React, { useState, createContext, useEffect, useContext } from 'react';
import { message } from 'antd';

import { fetchWithAccessTokenRetry } from '../helperFunctions.jsx';
import EntitiesPage from './EntitiesPage/EntitiesPage.jsx';
import ProjectionsPage from './ProjectionsPage/ProjectionsPage.jsx';
import Dashboard from './DashboardOverview/Dashboard.jsx';

export const CriticalFinancePageContext = createContext(null);

/* USES CLASSES SUCH AS form-input from PreNumbersCFI.css*/

function PageSwitcher() {
  const { pageNum } = useContext(CriticalFinancePageContext);

  switch (pageNum) {
    case 1: return <EntitiesPage />;
    case 2: return <ProjectionsPage />;
    case 3: return <Dashboard />;
    default: return <EntitiesPage />;
  }
}

async function getAllUserEntities(setEntities, setSpotRates, messageApi) {
  messageApi.info('Loading entities...');
  try {
    const response = await fetchWithAccessTokenRetry('/api/cfi/getEntities');
    if (!response.ok) {
      throw new Error('Failed to fetch entities');
    }
    const data = await response.json();
    setEntities(data.entities);
    setSpotRates(data.spotRates);
    messageApi.destroy();
    messageApi.success('Companies loaded successfully');
  } catch (error) {
    console.error('Error fetching user entities:', error);
    setEntities([]); // Clear entities on error
    messageApi.destroy();
    messageApi.error('Failed to load entities');
  }
}

function CriticalFinancePage() {
  const [pageNum, setPageNum] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const [entities, setEntities] = useState([]);
  // This state is used to track the selected entity for navigation so in other pages it can be used to add more products
  const [entitySelectedID, setEntitySelectedID] = useState("");
  const [entitySelected, setEntitySelected] = useState(null);
  const [spotRates, setSpotRates] = useState(null);

  // adds a single updater that changes entitySelected and entities atomically
  const updateEntity = (updater) => { 
    setEntitySelected(prev => {
      const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater };
      setEntities(prevEntities => {
        const idx = prevEntities.findIndex(e => e.id === next.id);
        if (idx === -1) return prevEntities;
        const nextEntities = [...prevEntities];
        nextEntities[idx] = next;
        return nextEntities;
      });
      return next;
    });
  };


  const contextToUse = {
    pageNum,
    setPageNum,
    messageApi,
    entities,
    setEntities,
    entitySelectedID,
    setEntitySelectedID,
    entitySelected,
    setEntitySelected: updateEntity,
    spotRates,
  };

  useEffect(() => {
    getAllUserEntities(setEntities, setSpotRates, messageApi);
  }, [messageApi]);

  // Update the selected entity when the entitySelectedID changes
  useEffect(() => {
    if (entitySelectedID !== "-- Select a entity --") {
      const selectedEntity = entities.find(entity => entity.id === parseInt(entitySelectedID));
      setEntitySelected(selectedEntity);
    }
  }, [entitySelectedID, entities]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageNum])

  return (
    <>
      {contextHolder}
      <CriticalFinancePageContext.Provider value={contextToUse}>
        <PageSwitcher />
      </CriticalFinancePageContext.Provider>
    </>
  );
}

export default CriticalFinancePage;